export default __webpack_public_path__ + "static/media/Tiramisu.1cbe3cc7.jpg";